module.exports = __webpack_public_path__ + "fonts/CrimsonText-SemiBoldItalic.3e89c46b.woff";